import {HttpErrorResponse} from '@angular/common/http';
import {throwError} from 'rxjs';
import {ProductsError, ProductsErrors} from '../models/products-error';

export const productsErrorSelector = (err: any) => {
    const errorCode = ProductsErrors.Unknown;
    let message = '';
    if (err.constructor.name === HttpErrorResponse.name) {
        const error = <HttpErrorResponse>err;
        if (error.error && error.error.message) {
            message = error.error.message;
        }
    }

    return throwError(new ProductsError(
        errorCode,
        message,
        err
    ));
};
